import {Injectable, Injector} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

declare const abp: any; // Ensure "abp" global object is available

@Injectable({
    providedIn: 'root',
})
export class DataViewService {
    private readonly dataViewTemplatePath = 'Apps.Webshop.TileViewTemplate';

    private readonly legacyTemplate = 'legacy';
    private readonly defaultTemplate = 'legacy';

    // Dropdown options
    templateOptions = [
        { label: 'Legacy', value: 'legacy' },
        { label: 'Theme1', value: 'theme1' }
    ];

    private _defaultTemplate$: BehaviorSubject<string>;

    constructor(injector: Injector) {
        const template = this._getTemplate();
        this._defaultTemplate$ = new BehaviorSubject<string>(template != null ? template : this.defaultTemplate);
    }

    //#region DataViewTemplate

    get currentTemplate(): string {
        return this._defaultTemplate$.value;
    }

    // Observable for DataViewTemplate
    get currentTemplate$(): Observable<string> {
        return this._defaultTemplate$.asObservable();
    }

    // Set DataViewTemplate
    setDataViewTemplate(template: string): void {
        this._defaultTemplate$.next(template);
    }

    get isLegacyTemplate(): boolean {
        return this.currentTemplate === this.legacyTemplate;
    }

    private _getTemplate(): string | null {
        return abp?.setting?.values[this.dataViewTemplatePath] || null;
    }
    //#endregion DataViewTemplate
}

